import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
} from 'recharts';
import type { WeeklyThroughput } from '@its4plan/ordering';
import { formatWeekLabel } from './chartUtils';
import useTranslate from '~/common/utils/translate';

interface Props {
  data: WeeklyThroughput[];
}

const MIN_BAR_WIDTH = 50;

export const WeeklyThroughputChart: React.FC<Props> = ({ data }) => {
  const t = useTranslate();
  const chartData = data.map((d) => ({
    label: formatWeekLabel(d.year, d.week),
    totalDoneAmount: d.totalDoneAmount,
  }));
  const chartWidth = Math.max(chartData.length * MIN_BAR_WIDTH, 300);

  return (
    <Box bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="lg" p={3}>
      <Text fontSize="sm" fontWeight="600" mb={2}>
        {t('projectRecords.chart.weeklyThroughput')}
      </Text>
      <Box overflowX="auto">
        <Box minW={`${chartWidth}px`} h="200px">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <XAxis dataKey="label" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="totalDoneAmount" fill="#38a169" />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    </Box>
  );
};
